module.exports = __webpack_public_path__ + "static/img/dash-gauge.04da9c6d.svg";